import { useCallback } from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { PageRenderer } from '@trinity/chat-components/components/PageDashboard/PageRenderer/index.js';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { useActiveBrandIdentifier } from '@trinity/chat-components/containers/UserBrands/useActiveBrandIdentifier.js';
import { useParams } from 'react-router-dom';

const Root = styled(Box)({
  width: '85%',
  maxWidth: '85%',
  height: 'calc(100vh - var(--navbar-height))',
  overflow: 'hidden',
  margin: '0 auto',
  boxSizing: 'border-box',
});

type RouteParams = {
  pageId: string;
};

export function PageScreen(): React.ReactElement {
  const { pageId } = useParams<RouteParams>();
  const apiClient = useChatApiClient();
  const brandIdentifier = useActiveBrandIdentifier();

  const proxyFetch = useCallback(
    ({ agentId, extensionPath }: { agentId: number; extensionPath: string }) =>
      apiClient.pages.proxyWidgetData(agentId, extensionPath, brandIdentifier ?? undefined),
    [apiClient, brandIdentifier],
  );

  const numericPageId = pageId ? +pageId : NaN;

  if (!pageId || isNaN(numericPageId)) {
    return <Box />;
  }

  return (
    <Root>
      <PageRenderer pageId={numericPageId} proxyFetch={proxyFetch} brandIdentifier={brandIdentifier ?? undefined} />
    </Root>
  );
}
